import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getIntubationSelector } from '../selectors'
import { saveIntubation } from '../store/intubation.actions'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setComments() {
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { comments } = intubationState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.intubationStateList && pcrDoc.patient?.intubationStateList.length) {
        const index = pcrDoc.patient?.intubationStateList?.findIndex(
          (intubation) => intubation.key === intubationState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.intubationStateList[index].comments !== comments) {
            yield put(saveIntubation())
          }
        }
      } else {
        yield put(saveIntubation())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([IntubationConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
